import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/position/importer/positionImporterActions';

export default importerReducers(actions);
